var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCrossDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.9974 18.3332C14.5998 18.3332 18.3307 14.6022 18.3307 9.99984C18.3307 5.39746 14.5998 1.6665 9.9974 1.6665C5.39502 1.6665 1.66406 5.39746 1.66406 9.99984C1.66406 14.6022 5.39502 18.3332 9.9974 18.3332Z",
    fill: "#E7EAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8802 9.9998L12.7969 8.08314C13.0385 7.84147 13.0385 7.44147 12.7969 7.1998C12.5552 6.95814 12.1552 6.95814 11.9135 7.1998L9.99687 9.11647L8.08021 7.1998C7.83854 6.95814 7.43854 6.95814 7.19687 7.1998C6.95521 7.44147 6.95521 7.84147 7.19687 8.08314L9.11354 9.9998L7.19687 11.9165C6.95521 12.1581 6.95521 12.5581 7.19687 12.7998C7.32187 12.9248 7.48021 12.9831 7.63854 12.9831C7.79687 12.9831 7.95521 12.9248 8.08021 12.7998L9.99687 10.8831L11.9135 12.7998C12.0385 12.9248 12.1969 12.9831 12.3552 12.9831C12.5135 12.9831 12.6719 12.9248 12.7969 12.7998C13.0385 12.5581 13.0385 12.1581 12.7969 11.9165L10.8802 9.9998Z",
    fill: "#E7EAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCrossDark);
export default __webpack_public_path__ + "static/media/blue-cross-dark.be36d4d2bfebb2f5be0089b3ce373a17.svg";
export { ForwardRef as ReactComponent };